<div nz-row class="company-intro-image"></div>
<div class="background-circles"></div>
<div nz-row class="message-title center-parent" style="margin-bottom: 0px;">
  <span class="title align-center">연혁</span>
  <div class="content" style="color: #707070; text-align: left; margin-left: 25%; margin-top: 120px;">
    <div class="history-year" nz-col style="float: left; margin-right: 100px;"> Since 2001</div>
    <div style="float: left;" nz-col>
      <div class="history-item" nz-row>
        <div class="history-year" nz-col>2023</div>
        <div style="margin-left: 100px;" nz-col>
          <div class="history-month">12월<br/>03월
          </div>
          <div class="history-message">연 매출 1천억원 초과 달성<br/>공동대표이사 천명환, 정해수 선임
          </div>
        </div>
      </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2020</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">02월</div>
        <div class="history-message">천안공장 SALVAGNINI FMS S4+P4 자동화 설비 도입 완료</div>
      </div>
    </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2019</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">11월</div>
        <div class="history-message">천안 제 2공장 준공</div>
      </div>
    </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2018</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">12월</div>
        <div class="history-message">18년 연매출 929억원 달성</div>
      </div>
    </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2017</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">12월<br/>
          02월</div>
        <div class="history-message">17년 연매출 895억원 달성<br/>
          천안공장 AMADA DCT-3065구매</div>
      </div>
    </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2015</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">03월</div>
        <div class="history-message">천안공장 AMADA EMZ-3510M II구매</div>
      </div>
    </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2013</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">06월</div>
        <div class="history-message">천안공장 TRUMPF TruLaser 1030 fiber 구매</div>
      </div>
    </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2012</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">10월<br/>
        03월</div>
        <div class="history-message">RFID Metal TAG 특허 취득<br/>
          ISO 14001 획득</div>
      </div>
    </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2010</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">11월<br/>
          10월<br/>
          08월<br/>
          03월</div>
        <div class="history-message">3천만 불 수출의 탑 수상<br/>
          ISO 9001 획득<br/>
          본사 사옥 준공<br/>
          천안공장 준공</div>
      </div>

    </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2009</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">12월<br/>
        11월</div>
        <div class="history-message">09년 연매출 566억원 달성<br/>
          2천만불 수출의 탑 수상</div>
      </div>
    </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2008</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">12월</div>
        <div class="history-message">08년 연매출 284억원 달성</div>
      </div>
    </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2007</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">12월</div>
        <div class="history-message">정밀판금사업부 신설 [천안공장]</div>
      </div>
    </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2006</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">07월</div>
        <div class="history-message">현대그린테크(주) 출범</div>
      </div>
    </div>
    <div class="history-item" nz-row>
      <div class="history-year" nz-col>2001</div>
      <div style="margin-left: 100px;" nz-col>
        <div class="history-month">09월<br/>
          03월</div>
        <div class="history-message">HYNIX Agent 계약체결<br/>
          현대디지텍(주)출범 [구_현대전자산업 분사]</div>
      </div>
    </div>
  </div>
</div>
</div>

  <div class="main-footer" style="margin-top: 350px;" nz-row>
    <p>COPYRIGHT BY (C) 2009 HYUNDAI GREEN TECH ALL RIGHTS RESERVED.<br/>
      [SEOUL]  T 02-2115-8815  F 02-2115-8818  [CHEON-AN] T 041-582-2214, 2215  F 041-588-2215</p>
</div>
